import { useFetch } from 'app/queryProvider';
import { TDevice } from '../types/deviceTypes';

export const usePatientDevices = () => {
  const { data, isLoading, error } = useFetch<TDevice[]>({
    url: '/my-devices',
    queryKey: [['pathways', 'my-devices']],
    resource: { name: 'pathways' },
    options: {
      staleTime: 10 * 60 * 1000,
    },
  });

  return {
    devices: data ?? [],
    isLoading,
    error,
  };
};
